import { useState } from 'react';
import { AxiosError } from 'axios';
import useError from 'components/ErrorProvider/useError';
import { IPartnerUgoRating } from '../../interfaces';
import { savePartnerUgoRating } from './api';

export function useSavePartnerRating(onSave?: () => void) {
  const [loading, setLoading] = useState(false);

  const { addError } = useError();

  const saveRating = async (data: IPartnerUgoRating[]) => {
    setLoading(true);

    try {
      await savePartnerUgoRating(data);

      onSave?.();
    } catch (error) {
      addError((error as AxiosError).response?.data.message);
    } finally {
      setLoading(false);
    }
  };

  return { loading, saveRating };
}
